<template>
  <div class="forms">
    <div class="form-group">
      <input type="text" class="form-control" v-model="match" placeholder="Матч:" @keyup.enter="goMatch" @input="checkFetchMatchTournaments" />
    </div>
    <div class="flex">
      <button type="button" class="btn btn-secondary" @click="goMatch">
        GO
      </button>
      <span v-if="matchTournamentsLoading" class="season-status" title="Загружаем список сезонов">⏳</span>
      <transition name="fade">
        <select
          v-if="matchTournaments.length > 0"
          class="form-control season-select"
          v-model="selectedMatchTournament"
          @change="onSeasonChange"
          :title="seasonSource === 'loaded'
            ? 'Перезагрузить открытый матч за выбранный сезон/турнир'
            : 'Сезон/турнир, за который брать статистику игроков'"
        >
          <option value="">Текущий сезон</option>
          <option v-for="t in matchTournaments" :key="t.value" :value="t.value">{{ t.name }}</option>
        </select>
      </transition>
    </div>
    
    <transition name="fade">
      <div class="form-group" v-if="addPriceTeamA">
        <input type="text" class="form-control" v-model="priceLinkTeamA" placeholder="TM Команда А" @keyup.enter="AddPrice('teamA')" />
      </div>
    </transition>
    <transition name="fade">
      <div class="flex" v-if="addPriceTeamA && priceLinkTeamA !== ''">
        <button type="button" class="btn btn-secondary" @click="AddPrice('teamA')">GO</button>
      </div>
    </transition>
    <transition name="fade">
      <div class="form-group" v-if="addPriceTeamB">
        <input type="text" class="form-control" v-model="priceLinkTeamB" placeholder="TM Команда B" @keyup.enter="AddPrice('teamB')" />
      </div>
    </transition>
    <transition name="fade">
      <div class="flex" v-if="addPriceTeamB && priceLinkTeamB !== ''">
        <button type="button" class="btn btn-secondary" @click="AddPrice('teamB')">GO</button>
      </div>
    </transition>

    <div class="form-group">
      <input type="text" class="form-control" v-model="teamA" placeholder="Ссылка на команду A:" @input="checkFetchTournaments('A')" />
    </div>
    <transition name="fade">
      <div class="form-group" v-if="tournamentsA.length > 0">
        <select class="form-control" v-model="selectedTournamentA">
          <option value="">Все турниры (По умолчанию)</option>
          <option v-for="t in tournamentsA" :key="t.value" :value="t.value">{{ t.name }}</option>
        </select>
      </div>
    </transition>

    <div class="form-group">
      <input type="text" class="form-control" v-model="teamB" placeholder="Ссылка на команду B:" @input="checkFetchTournaments('B')" />
    </div>
    <transition name="fade">
      <div class="form-group" v-if="tournamentsB.length > 0">
        <select class="form-control" v-model="selectedTournamentB">
          <option value="">Все турниры (По умолчанию)</option>
          <option v-for="t in tournamentsB" :key="t.value" :value="t.value">{{ t.name }}</option>
        </select>
      </div>
    </transition>

    <div class="flex">
      <button type="button" class="btn btn-secondary" @click.prevent="parseCustomTeams">
        GO Team
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputForms",
  data: () => ({
    regMatches: /int\.soccerway\.com\/matches\//gi,
    teamA: "",
    teamB: "",
    match: "",
    what: ["match", "teamA", "teamB"],
    addPriceTeamA: false,
    addPriceTeamB: false,
    priceLinkTeamA: "",
    priceLinkTeamB: "",
    priceTeamAName: "",
    priceTeamBName: "",
    
    tournamentsA: [],
    tournamentsB: [],
    selectedTournamentA: "",
    selectedTournamentB: "",

    // Сезоны по ссылке на матч (выпадающее меню рядом с кнопкой GO)
    matchTournaments: [],
    selectedMatchTournament: "",
    matchTournamentsLoading: false,
    lastMatchUrlFetched: "",
    matchTournamentsTimer: null,
    // 'input'  — список для ссылки, вставленной в поле «Матч» (применится по кнопке GO)
    // 'loaded' — список для уже открытого матча (выбор сразу перезагружает его за сезон)
    seasonSource: "input"
  }),
  methods: {
    // Матч открыли из сохранённых — подтягиваем его сезоны в тот же селект.
    // Список берём с команды хозяев: на ТМ селектор сезонов общий для обеих.
    async fetchSeasonsForLoadedMatch() {
      const m = this.loadedMatch;
      if (!m || !m.teamA || !m.teamA.href || m.competition === 'Custom Match') {
        if (this.seasonSource === 'loaded') {
          this.matchTournaments = [];
          this.selectedMatchTournament = "";
        }
        return;
      }

      this.seasonSource = 'loaded';
      this.matchTournamentsLoading = true;
      try {
        const response = await fetch('/api/tournaments', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url: m.teamA.href })
        });
        const data = await response.json();
        this.matchTournaments = Array.isArray(data) ? data : [];
        // Показываем в селекте сезон, за который матч уже загружен
        this.selectedMatchTournament = m.seasonValue || "";
      } catch (error) {
        console.error('Ошибка загрузки сезонов открытого матча:', error);
        this.matchTournaments = [];
      } finally {
        this.matchTournamentsLoading = false;
      }
    },

    onSeasonChange() {
      // В режиме вставленной ссылки сезон применяется кнопкой GO, сразу ничего не делаем
      if (this.seasonSource !== 'loaded') return;
      this.reloadLoadedMatchWithSeason(this.selectedMatchTournament);
    },

    async reloadLoadedMatchWithSeason(value) {
      const m = this.loadedMatch;
      const rawUrl = m.matchUrl || m.url;
      const idMatch = String(rawUrl || '').split('?')[0].match(/\/(\d+)\/?$/);

      if (!idMatch) {
        alert("Не удалось определить ссылку на матч — перезагрузить за другой сезон нельзя.");
        return;
      }

      const url = `https://www.transfermarkt.com/spielbericht/index/spielbericht/${idMatch[1]}`;
      const picked = this.matchTournaments.find(t => t.value === value);

      try {
        const parsed = await this.$store.dispatch("PARSE_URL", {
          url,
          team: this.what[0],
          tournament: value
        });

        parsed.seasonValue = value || "";
        parsed.seasonLabel = picked ? picked.name : "";
        // Лигу и страну сохраняем от исходного матча, иначе он выпадет из своей группы
        if (m.competition) parsed.competition = m.competition;
        if (m.competitionId) parsed.competitionId = m.competitionId;

        document.title = `${parsed.teamA.name} - ${parsed.teamB.name}`;
        await this.$store.dispatch("ADD_SAVED_MATCHES", { ...parsed });
        await this.$store.dispatch("GET_SAVED_COLOR");
      } catch (error) {
        console.error("Ошибка при загрузке матча за выбранный сезон:", error);
        alert("Не удалось загрузить матч за выбранный сезон.");
      }
    },

    // Ссылка на матч вставлена → подтягиваем список сезонов.
    // Дебаунс, чтобы при ручном наборе не долбить Transfermarkt на каждый символ.
    checkFetchMatchTournaments() {
      const url = this.match.trim();

      // Ссылка может быть с чужим доменом и слагом команд — проверяем только номер матча
      if (!/spielbericht\/(?:index\/spielbericht\/)?\d+/.test(url)) {
        this.matchTournaments = [];
        this.selectedMatchTournament = "";
        this.lastMatchUrlFetched = "";
        // Поле очистили — возвращаем в селект сезоны открытого матча
        this.fetchSeasonsForLoadedMatch();
        return;
      }
      if (url === this.lastMatchUrlFetched) return;

      clearTimeout(this.matchTournamentsTimer);
      this.matchTournamentsTimer = setTimeout(() => this.fetchMatchTournaments(url), 400);
    },

    async fetchMatchTournaments(url) {
      this.lastMatchUrlFetched = url;
      this.seasonSource = 'input';
      this.matchTournamentsLoading = true;
      try {
        const response = await fetch('/api/match-tournaments', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url })
        });
        const data = await response.json();
        this.matchTournaments = Array.isArray(data) ? data : [];
        this.selectedMatchTournament = "";
      } catch (error) {
        console.error('Ошибка загрузки сезонов по ссылке матча:', error);
        this.matchTournaments = [];
      } finally {
        this.matchTournamentsLoading = false;
      }
    },

    checkFetchTournaments(team) {
      const url = team === 'A' ? this.teamA : this.teamB;
      if (url.includes('transfermarkt.com') || url.includes('transfermarkt.ru')) {
        this.fetchTournaments(url, team);
      }
    },
    async fetchTournaments(url, team) {
      try {
        const backendUrl = `/api/tournaments`;
        
        const response = await fetch(backendUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url: url.trim() })
        });
        const data = await response.json();
        
        if (team === 'A') this.tournamentsA = data;
        if (team === 'B') this.tournamentsB = data;
      } catch (error) {
        console.error(`Ошибка загрузки турниров для Команды ${team}:`, error);
      }
    },

    async AddPrice(team) {
      if (team === "teamA") {
        try {
          const price = await this.$store.dispatch("ADD_TM_NAME", {
            soccerway: this.priceTeamAName,
            tm_link: this.priceLinkTeamA,
          });
          this.$store.commit("SET_PRICE", price);
        } catch (e) {
          console.error('Error', e);
        } finally {
          this.addPriceTeamA = false;
          this.priceTeamAName = "";
          this.priceLinkTeamA = "";
        }
      } else if (team === "teamB") {
        try {
          const price = await this.$store.dispatch("ADD_TM_NAME", {
            soccerway: this.priceTeamBName,
            tm_link: this.priceLinkTeamB,
          });
          this.$store.commit("SET_PRICE", price);
        } catch (e) {
          console.error('Error', e);
        } finally {
          this.addPriceTeamB = false;
          this.priceTeamBName = "";
          this.priceLinkTeamB = "";
        }
      }
    },
    
    async CheckPriceByTeam(teamA, teamB) {
      this.priceTeamAName = teamA.name;
      try {
        const PA = await this.$store.dispatch("CHECK_PRICE", teamA.name);
        if (!this.isEmptyObject(PA)) {
          if (!this.isEmptyObject(PA.message)) this.addPriceTeamA = true;
          else this.$store.commit("SET_PRICE", PA);
        }
      } catch (e) {
        // Ошибка 404 упадет сюда и скрипт пойдет дальше
      }

      this.priceTeamBName = teamB.name;
      try {
        const PB = await this.$store.dispatch("CHECK_PRICE", teamB.name);
        if (!this.isEmptyObject(PB)) {
          if (!this.isEmptyObject(PB.message)) this.addPriceTeamB = true;
          else this.$store.commit("SET_PRICE", PB);
        }
      } catch (e) {
        // Ошибка 404 упадет сюда
      }
    },

    /**
     * Вставка из онлайнпроги: «ONLINEPARS1 {json}» — матч вместе с составами.
     * Возвращает {tm, A, B} или null, если это обычная ссылка.
     * Только для админа: у остальных пользователей своя разметка составов, и затирать её
     * чужим импортом нельзя. Не админ вставил такую строку — берём из неё только id матча.
     */
    parseOnlineparsPayload(raw) {
      const MARK = "ONLINEPARS1 ";
      const text = String(raw || "").trim();
      if (!text.startsWith(MARK)) return null;
      let data;
      try {
        data = JSON.parse(text.slice(MARK.length));
      } catch (e) {
        console.error("Не разобрали вставку из онлайнпроги:", e.message);
        return null;
      }
      if (!data || !data.tm) return null;
      data.isAdmin = this.$store.getters.premissions === "admin";
      return data;
    },

    /**
     * Составы приехали для ТОГО ЖЕ матча, что открыт сейчас?
     * Сверяем по id матча ТМ, а если открыт кастомный матч (собран из двух ссылок,
     * id у него выдуманный) — по именам команд.
     */
    payloadMatchesOpened(payload, match) {
      const digits = (s) => (String(s || "").match(/(\d+)/g) || []).pop() || "";
      const openedId = digits(match.matchUrl || match.url || match.id);
      if (openedId && String(payload.tm) === openedId) return true;

      const norm = (s) => String(s || "")
        .normalize("NFD").replace(/[̀-ͯ]/g, "")
        .toLowerCase().replace(/[^a-z0-9]/g, "");
      const a = norm(match.teamA && match.teamA.name);
      const b = norm(match.teamB && match.teamB.name);
      // Кастомный матч: id не сверить, полагаемся на имена
      if (!openedId) return a === norm(payload.hA) && b === norm(payload.hB);
      return false;
    },

    async goMatch() {
      if (this.match !== "") {
        this.addPriceTeamA = false;
        this.addPriceTeamB = false;

        // Матч мог приехать из онлайнпроги вместе с составами — тогда в поле лежит
        // не ссылка, а payload. Ссылку для парсинга собираем из его tm-id.
        const imported = this.parseOnlineparsPayload(this.match);

        // Режим «только составы»: матч не трогаем, красим уже открытый.
        if (imported && imported.mode === "lu") {
          this.match = "";
          if (!imported.isAdmin) return;   // остальным пользователям фича не видна

          const opened = this.$store.getters.matches;
          if (!opened || !opened.teamA || !opened.teamA.squad) {
            this.$notify({ group: "app", type: "warn", title: "Сначала открой матч",
                           text: "Составы вставляются в уже загруженный матч." });
            return;
          }
          if (!this.payloadMatchesOpened(imported, opened)) {
            this.$notify({ group: "app", type: "error", title: "Это составы другого матча",
                           text: `Открыт ${opened.teamA.name} — ${opened.teamB.name}, ` +
                                 `а вставлен ${imported.hA} — ${imported.hB}. Ничего не менял.` });
            return;
          }

          const res = await this.$store.dispatch("IMPORT_LINEUP", imported);
          const missed = (res && res.missed) || [];
          this.$notify({
            group: "app",
            type: missed.length ? "warn" : "success",
            title: `Составы проставлены: ${res ? res.applied : 0} игроков`,
            text: missed.length ? `Не нашлись в ТМ: ${missed.join(", ")}` : "Старые метки LU заменены."
          });
          return;
        }
        const urlToParse = imported
          ? `https://www.transfermarkt.com/spielbericht/index/spielbericht/${imported.tm}`
          : this.match;

        const match = await this.$store.dispatch("PARSE_URL", {
          url: urlToParse,
          team: this.what[0],
          tournament: this.selectedMatchTournament
        });
        document.title = `${match.teamA.name} - ${match.teamB.name}`;

        // Подпись выбранного сезона — показывается в списке сохранённых после названий команд
        const picked = this.matchTournaments.find(t => t.value === this.selectedMatchTournament);
        match.seasonLabel = picked ? picked.name : "";
        // Значение reldata нужно, чтобы перепарсить матч за тот же сезон
        match.seasonValue = this.selectedMatchTournament || "";

        await this.$store.dispatch("ADD_SAVED_MATCHES", {
          ...match,
        });
        this.match = "";
        this.matchTournaments = [];
        this.selectedMatchTournament = "";
        this.lastMatchUrlFetched = "";
        await this.$store.dispatch("GET_SAVED_COLOR");

        // Список сезонов для только что созданного матча. Сам по себе он не
        // подтянется: watcher срабатывает в момент SET_MATCH внутри PARSE_URL,
        // когда в поле «Матч» ещё лежит ссылка, и выходит по своей проверке,
        // а список, собранный по ссылке, мы только что очистили. Поэтому
        // селект сезонов появлялся лишь у матчей, открытых из сохранённых.
        this.fetchSeasonsForLoadedMatch();

        // Составы из онлайнпроги проставляем ПОСЛЕ GET_SAVED_COLOR: тот подтягивает
        // сохранённые кружки с сервера и иначе затёр бы только что импортированные.
        if (imported) {
          if (!imported.isAdmin) {
            // Не админ — молча: матч просто загружен по id, никаких кружков и никаких
            // сообщений. Для остальных пользователей фича не должна проявляться вообще.
          } else {
            const res = await this.$store.dispatch("IMPORT_LINEUP", imported);
            const missed = (res && res.missed) || [];
            this.$notify({
              group: "app",
              type: missed.length ? "warn" : "success",
              title: `Составы перенесены: ${res ? res.applied : 0} игроков`,
              text: missed.length ? `Не нашлись в ТМ: ${missed.join(", ")}` : ""
            });
          }
        }
      }
    },

    async parseCustomTeams() {
      if (this.teamA !== "" && this.teamB !== "") {
        const rawUrlA = this.teamA.trim();
        const rawUrlB = this.teamB.trim();

        this.addPriceTeamA = false;
        this.addPriceTeamB = false;

        if (this.$store._mutations['SET_PRELOADER']) {
          this.$store.commit('SET_PRELOADER', true);
        }

        if (this.$store._mutations['CLEAR_SERVER_LOGS']) {
          this.$store.commit('CLEAR_SERVER_LOGS'); 
        }
        
        const logSource = new EventSource('/api/parse/logs');
        logSource.onmessage = (event) => {
          this.$store.commit('ADD_SERVER_LOG', event.data);
        };

        try {
          const backendUrl = `/api/parseTeams`;

          const response = await fetch(backendUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              urlA: rawUrlA,
              urlB: rawUrlB,
              tournamentA: this.selectedTournamentA,
              tournamentB: this.selectedTournamentB
            })
          });

          if (!response.ok) {
            throw new Error(`Server error: ${response.status}`);
          }

          const match = await response.json();

          if (match.teamA) {
            match.teamA.comment = '';
            match.teamA.addsquad = match.teamA.addsquad || [];
            match.teamA.squad = match.teamA.squad || [];
            match.teamA.href = rawUrlA;
          }
          if (match.teamB) {
            match.teamB.comment = '';
            match.teamB.addsquad = match.teamB.addsquad || [];
            match.teamB.squad = match.teamB.squad || [];
            match.teamB.href = rawUrlB;
          }

          // Генерируем фейковый ID для истории
          const customId = Math.floor(10000000 + Math.random() * 90000000).toString();
          
          match.id = customId;
          match.url = customId;
          match.matchUrl = customId;
          match.link = customId;
          match.competition = 'Custom Match';

          // 🔥 Прячем ссылки и выбранные турниры в браузер
          localStorage.setItem(`custom_urlA_${customId}`, rawUrlA);
          localStorage.setItem(`custom_urlB_${customId}`, rawUrlB);
          localStorage.setItem(`custom_tourA_${customId}`, this.selectedTournamentA || "");
          localStorage.setItem(`custom_tourB_${customId}`, this.selectedTournamentB || "");
          
          this.$store.commit('SET_MATCH', match);
          document.title = `${match.teamA.name} - ${match.teamB.name}`;
          
          // Сохраняем в базу
          await this.$store.dispatch("ADD_SAVED_MATCHES", { ...match });
          
          this.teamA = "";
          this.teamB = "";
          this.tournamentsA = [];
          this.tournamentsB = [];
          this.selectedTournamentA = "";
          this.selectedTournamentB = "";
          
          // Пытаемся проверить цены
          try {
            await this.CheckPriceByTeam(match.teamA, match.teamB);
          } catch (priceError) {
            console.warn("⚠️ Проверка цены не удалась (404), но матч сохранен!");
          }
          
          await this.$store.dispatch("GET_SAVED_COLOR");

        } catch (error) {
          console.error("Ошибка при парсинге:", error);
          alert("Ошибка при парсинге. Проверьте правильность ссылок на Transfermarkt.");
        } finally {
          if (logSource) {
            logSource.close();
          }
          
          if (this.$store._mutations['SET_PRELOADER']) {
            this.$store.commit('SET_PRELOADER', false);
          }
        }
      } else {
        alert("Пожалуйста, вставьте ссылки для обеих команд!");
      }
    },
    isEmptyObject(obj) { return obj && Object.keys(obj).length === 0 && obj.constructor === Object; }
  },
  watch: {
    // Открыли другой матч (из сохранённых или распарсили новый) — обновляем список сезонов.
    // Следим за ключом, а не за объектом: сам матч мутируется постоянно
    // (цвета, статусы), и на каждое изменение дёргать Transfermarkt нельзя.
    loadedMatchKey: {
      immediate: true,
      handler(key) {
        if (!key) return;
        if (this.match.trim()) return; // в поле есть ссылка — селект занят ею
        this.fetchSeasonsForLoadedMatch();
      }
    }
  },
  computed: {
    loadedMatch() {
      return this.$store.getters.matches || {};
    },
    loadedMatchKey() {
      const m = this.loadedMatch;
      if (!m || !m.teamA) return "";
      return `${m.savedId || m.id || m.matchUrl || ""}::${m.seasonValue || ""}`;
    },
    matches() {
      if (this.teamA !== "") {
        if (this.regMatches.test(this.teamA)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    getMatch() {
      return this.$store.getters.matches;
    },
  },
};
</script>

<style scoped lang="sass">
.forms
  display: flex
  justify-content: center
  div:nth-child(2)
    margin-right: 30px
.flex
  display: flex
  position: relative
  align-items: center
.form-group
  display: flex
  align-items: center
.season-select
  width: auto
  max-width: 220px
  margin-left: 6px
.season-status
  margin-left: 6px
</style>